import { defineStore } from 'pinia';

import { accountApiConfig } from '@/config/api/account';
import { useClientApi } from '@/plugins/api/lk';
import { useSentry } from '@/plugins/sentry';

export const useAccountStore = defineStore('account', () => {
  async function resetPassword (email: string): Promise<void> {
    try {
      const url = accountApiConfig.resetPassword;
      await useClientApi().post(url, {
        email,
      });
    } catch (error: unknown) {
      console.error('🚀 ~ file: account.ts ~ resetPassword ~ error', error);
      useSentry().captureException(error);
      throw error;
    }
  }

  return {
    resetPassword,
  };
});
